import list from './list'
import edit from '../pages/edit'

export default { list, edit, options: { label: 'Pages Apps' } }
